// SCRNITM#fx
export default [
  {
    name: 'FX',
    path: 'fx',
    meta: {
      auth: false
    },
    component: () => import(/* webpackChunkName: "fx" */ './FX.vue')
  }
]
